import { render, staticRenderFns } from "./BomTab.vue?vue&type=template&id=205cca33&"
import script from "./BomTab.vue?vue&type=script&lang=js&"
export * from "./BomTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports